/**
 * mk-legacy-atc.js — pont Speedfly -> tiroir Dawn
 *
 * POURQUOI CE FICHIER EXISTE
 * Les fiches produit n'utilisent pas <product-form>. Elles embarquent, dans un
 * bloc Custom Liquid répliqué dans ~17 templates (sélecteur "v4-compact"), leur
 * propre formulaire + un POST /cart/add.js maison qui se termine par :
 *
 *     if (Shopify.theme && Shopify.theme.jsAjaxCart) {
 *       Shopify.theme.jsAjaxCart.openCartDrawer();
 *     }
 *
 * `Shopify.theme.jsAjaxCart` vient de l'ancien thème Speedfly et n'existe pas
 * dans Dawn : la condition est toujours fausse, donc rien ne s'ouvrait. Ça
 * passait inaperçu tant que YMQ interceptait /cart/add.js globalement.
 *
 * Plutôt que de réécrire les 17 templates (fichiers auto-générés, écrasables
 * par l'éditeur de thème), on implémente l'API qu'ils appellent déjà.
 *
 * On ne définit openCartDrawer QUE s'il n'existe pas : si une app le fournit un
 * jour, elle garde la main.
 *
 * NB : l'appelant ne transmet pas `sections` à /cart/add.js, on ne peut donc pas
 * utiliser renderContents(). On re-rend le tiroir depuis /cart?section_id.
 */
(function () {
  window.Shopify = window.Shopify || {};
  Shopify.theme = Shopify.theme || {};
  Shopify.theme.jsAjaxCart = Shopify.theme.jsAjaxCart || {};

  if (typeof Shopify.theme.jsAjaxCart.openCartDrawer === 'function') return;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  Shopify.theme.jsAjaxCart.openCartDrawer = function () {
    const drawer = document.querySelector('cart-drawer');

    // Pas de tiroir (panier en mode page) : on bascule sur /cart.
    if (!drawer) {
      window.location = cartUrl();
      return;
    }

    Promise.all([
      fetch(`${cartUrl()}?section_id=cart-drawer`).then((r) => r.text()),
      fetch(`${cartUrl()}?section_id=cart-icon-bubble`).then((r) => r.text()),
    ])
      .then(([drawerHtml, bubbleHtml]) => {
        const parser = new DOMParser();

        const source = parser.parseFromString(drawerHtml, 'text/html').querySelector('#CartDrawer');
        const target = document.querySelector('#CartDrawer');
        if (source && target) target.innerHTML = source.innerHTML;

        const bubbleSource = parser.parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        const bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubbleSource && bubbleTarget) bubbleTarget.innerHTML = bubbleSource.innerHTML;

        // L'overlay vient d'être remplacé : son écouteur de fermeture, posé dans
        // le constructeur de CartDrawer, pointe sur un nœud détaché. On rebranche.
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));

        drawer.classList.remove('is-empty');
        drawer.open();
      })
      .catch((error) => {
        console.error('[mk-legacy-atc] ouverture du tiroir', error);
        window.location = cartUrl();
      });
  };
})();
